import { createFileRoute } from "@tanstack/react-router"
import { AdminEmailsPage } from "@/components/pages/AdminEmailsPage"

// `/admin/emails` — the email sender. Guard inherited from the parent layout.
export const Route = createFileRoute(`/_authenticated/admin/emails`)({
  component: AdminEmailsPage,
  ssr: false,
})
